import React from "react";
import Modal from "react-modal";
import { motion } from "framer-motion";
import { LazyMotion, domAnimation } from "framer-motion";
function NftPopup(props) {
  // const openModal = () => {
  //     props.setShow(true);
  // };

  const afterOpenModal = () => {
    // references are now sync'd and can be accessed.
    //   subtitle.style.color = '#f00';
  };

  const closeModal = () => {
    props.setShow(false);
  };
  return (
    <LazyMotion features={domAnimation}>
      <motion.div
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <Modal
          isOpen={props.show}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          //   style={customStyles}
          contentLabel="Example Modal"
          className="signup-modal"
        >
          <section className="nft-popup">
            <div className="row">
              <div className="col-lg-12">
                <h1>Complete checkout</h1>
              </div>
              <div className="row nft-pop-head">
                <div className="col-lg-6">
                  <p>Item</p>
                </div>
                <div className="col-lg-6">
                  <p>Total</p>
                </div>
              </div>
              <div className="row nft-pop-body">
                <div className="col-lg-2">
                  <img
                    src={require(".././Assets/img/pop-card.png")}
                    className="card-img"
                    alt=""
                  />
                </div>
                <div className="col-lg-8">
                  <h3>Gaming Arcade-Alpha Pass</h3>
                  <h2>Alpha pass</h2>
                  <div className="creator">
                    <h4>Creator Fees: 0%</h4>
                    <img
                      src={require(".././Assets/img/icon-exam.png")}
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-lg-2">
                  <div className="poly-vec-price">
                    <img src={require(".././Assets/img/poly-vec.png")} alt="" />
                    <p>0.3</p>
                  </div>
                  <h3>$0.28</h3>
                </div>
              </div>
              <div className="row nft-pop-wallet">
                <div className="col-lg-6 wallet">
                  <img src={require(".././Assets/img/wallet.png")} alt="" />
                  <p>Send to different wallet</p>
                </div>
              </div>
              <div className="row nft-pop-button">
                <div className="col-lg-12">
                  <button onClick={() => closeModal()}>
                    Complete purchase
                  </button>
                </div>
              </div>
            </div>
          </section>
        </Modal>
      </motion.div>
    </LazyMotion>
  );
}
export default NftPopup;
